import './App.css';
import WarningDialogue from "./Components/WarningDialogue/WarningDialogue";
import Loader from "./Components/Loader/Loader";
import MyRouter from './Routes/MyRouter';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { fetchUserDetails } from './Store/actions/UsersActions';
import { fetchFeaturedCollection } from './Store/actions/FeaturedCollectionActions';
import { fetchGalleryByType } from './Store/actions/GalleryActions';
import { fetchAllBlogs, getBlogCategories } from './Store/actions/BlogsAction';
import { fetchAllBookColors } from './Store/actions/BookColorAction';
import { fetchAllVideos } from './Store/actions/ServiceVideoAction';
import { addBestSellerCartItem, addCartItem, fetchAllCartItems } from './Store/actions/CartAction';
import { isUserLoggedIn } from './Util';
import { fetchAllWishlistItems } from './Store/actions/WishlistAction';
import { CartActions } from './Store/Slices/CartSlice';
import VerificationPendingModal from './Components/verificationPendingModal/verificationPendingModal';
import { fetchBookById } from './Store/actions/BookAction';
import { fetchBookById as fetchBestSellerBook } from './Store/actions/BestSellerBookAction';
import SEO from './Components/SEO';

function App() {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.user.currentUser);
  const cartItems = useSelector((state) => state.cart.cartItems);
  const showMessage = useSelector((state) => state.verificationPending.showMessage);
  const isBlocked = useSelector((state) => state.blocked.isBlocked);

  useEffect(() => {
    if(!isBlocked){
    fetchAllBookColors(dispatch);
    dispatch(fetchUserDetails())
    fetchAllBlogs(dispatch);
    getBlogCategories(dispatch);
    fetchAllVideos(dispatch)
    if (isUserLoggedIn()) {
      fetchAllCartItems(dispatch);
      fetchAllWishlistItems(dispatch);
    } 
    fetchGalleryByType(dispatch);
    fetchFeaturedCollection(dispatch);
  }
  },[dispatch])

  const syncCartOnLogin = async () => {
    const guestCart = JSON.parse(localStorage.getItem("guestCart")) || [];
  
    if (guestCart.length > 0) {
      // Call API to sync cart items
      dispatch(CartActions.addCartItemSuccess([]));
      
      // Process items sequentially to maintain order
      for (const item of guestCart) {
        if (item.book) {
          try {
            const bookResponse = await fetchBookById(item.book.id, dispatch);
            const book = bookResponse?.[0]
            addCartItem(
              book,
              item.quantity,
              item.variantType,
              item.leatherType,
              item.color,
              dispatch
            );
          } catch (error) {
            console.error("Error fetching book:", error);
          }
        } else {
          try {
            const bestSellerBook = await fetchBestSellerBook(item?.bestSellerBook?.id, dispatch);
            addBestSellerCartItem(
              bestSellerBook,
              item.quantity,
              item.variantType,
              item.leatherType,
              item.color,
              dispatch
            );
          } catch (error) {
            console.error("Error fetching bestseller book:", error);
          }
        }
      }
  
      // Clear local storage once synced
      localStorage.removeItem("guestCart");
    }
  };
  useEffect(() => {
    if (currentUser?.id) {
      syncCartOnLogin();
    }
  }, [currentUser]);

  useEffect(() => {
    const guestCart = localStorage.getItem("guestCart") || [];
    if(!currentUser?.id && cartItems?.length === 0 && guestCart?.length !== 0) {
        dispatch(CartActions.addCartItemSuccess(JSON.parse(guestCart)))
    }
  },[])

  const defaultSEO = {
    defaultTitle: 'Rare Biblio | Leather-Bound Books, PDF to Print, Restoration',
    defaultDescription: "Explore Rare Biblio’s custom leather-bound books, expert PDF-to-print & book restoration services. Perfect for collectors, gifting & timeless bookshelf charm. ",
    defaultCanonicalUrl: 'https://rarebiblio.com/',
    keywords: "Rare Books"
  };

  if (isBlocked) {
    return (
      <>
              <SEO structuredData={{
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Rare Biblio",
        "alternateName": "Rare Biblio",
        "url": "https://www.rarebiblio.com/",
        "publisher": {
          "@type": "Organization",
          "name": "Rare Biblio",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.rarebiblio.com/Assets/Icons/logo.jpg"
          }
        },
        "sameAs": [
          "https://www.facebook.com/rarebiblio/",
          "https://www.instagram.com/Rarebiblio/",
          "https://www.linkedin.com/company/Rarebiblio",
          "https://in.pinterest.com/rare_biblio/",
          "https://x.com/Rarebiblio"
        ]
      }} {...defaultSEO} />
        <main
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '80vh',
            fontFamily: 'system-ui, sans-serif',
            backgroundColor: '#f9f9f9',
            color: '#333',
          }}
        >
          <h1 style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>Unavailable</h1>
          <p style={{ fontSize: '1rem' }}>
          The webpage is under construction
          </p>
        </main>
      </>
    );
  }
  

  return (
    <>
      <SEO structuredData={{
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Rare Biblio",
        "alternateName": "Rare Biblio",
        "url": "https://www.rarebiblio.com/",
        "publisher": {
          "@type": "Organization",
          "name": "Rare Biblio",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.rarebiblio.com/Assets/Icons/logo.jpg"
          }
        },
        "sameAs": [
          "https://www.facebook.com/rarebiblio/",
          "https://www.instagram.com/Rarebiblio/",
          "https://www.linkedin.com/company/Rarebiblio",
          "https://in.pinterest.com/rare_biblio/",
          "https://x.com/Rarebiblio"
        ]
      }} {...defaultSEO} />
      <div className='App'>
        <WarningDialogue />
        <MyRouter />
        <Loader />
        {showMessage && <VerificationPendingModal />}
      </div>
    </>

  );
}

export default App;
